export default __webpack_public_path__ + "static/media/logoWhite.6cef7a55.png";